import React, { useState } from 'react';
import { GoogleMap, useJsApiLoader, HeatmapLayer } from '@react-google-maps/api';
import { useAuth } from '../../../Auth/AuthContext';
import CargandoSpinner from '../../Utils/CargandoSpinner';  
import SeccionPageHeader from '../../Utils/SeccionPageHeader';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import geocodeAddresses from './geocodeAddresses';

const containerStyle = {
    width: '100%',
    height: '400px',
};

// Set Medellín, Colombia as the default center
const center = {
    lat: 6.2442, // Latitude for Medellín
    lng: -75.5812, // Longitude for Medellín
};

const ReporteMapaCalor = () => {
    const [locations, setLocations] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    // Load the Google Maps API asynchronously
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: import.meta.env.VITE_GOOGLE_API_KEY, // Use your API key
        libraries: ['visualization'], // Load the visualization library for heatmaps
    });

    async function cargarDireccionesDX() {
        const addresses = [
            "CLL 105 37 24, Medellín, Colombia",
            "CR 17B 56 EE 69, Medellín, Colombia",
            "CLL 53 3A - 20, Medellín, Colombia",
            "CALLE 39A 112 89 INT 110, Medellín, Colombia",
            "CLL107 51 63, Medellín, Colombia",
            "CLL 58 C 90 1 APTO 153, Medellín, Colombia",
            "CRR 81 92 62, Medellín, Colombia",
            "CLL 59 67D 06, Medellín, Colombia",
            "CLL 63 BB 105 99, Medellín, Colombia",
            "CLL 78 50B 103, Medellín, Colombia",
            "CLL 77C 93A, Medellín, Colombia",
            "CLL 1B 77A 02, Medellín, Colombia",
            "CR 99EE 49AA 111, Medellín, Colombia",
            "CLL 55 7 27, Medellín, Colombia",
            "CRR 35A 94 04, Medellín, Colombia",
            "CR 9A 49 29 INTERIOR 215, Medellín, Colombia",
            "CL 60 59 21, Medellín, Colombia",
            "CRR 71 CLL 95 84, Medellín, Colombia",
            "CR 99 44 26, Medellín, Colombia",
            "CL 98 69 64, Medellín, Colombia",
        ];
        setCargando(true);
        const result = await geocodeAddresses(addresses);
        setCargando(false);
        setLocations([...locations, ...result.map((res) => ({ location: new window.google.maps.LatLng(res.location.lat, res.location.lng), weight: 1 }))]);
        console.log(result);
    }


    const handleFormSubmit = (e) => {
        e.preventDefault();
        const lat = parseFloat(e.target.lat.value);
        const lng = parseFloat(e.target.lng.value);
        const weight = parseFloat(e.target.weight.value) || 1; // Default weight is 1
        setLocations([...locations, { location: new window.google.maps.LatLng(lat, lng), weight }]);
    };

    if (!isLoaded) {
        return <div>Cargando...</div>; // Show a loading indicator while the API is being loaded
    }

    return (
        <div className="content-wrapper">
          <SeccionPageHeader 
            title="Recepción diagnostico base"
            idCabezaFamilia="0"
            url=""
            nombreurl="Recepción dx"
            nombreform="Crear"
            />
          <CargandoSpinner Cargando={Cargando}/>
          <section className="content">
            <div className="container-fluid">
              <div className="card card">
                  <div className="card-body">
                  <div>
                        <h1>Reporte Mapa de Calor</h1>
                        <form onSubmit={handleFormSubmit}>
                            <div>
                                <label htmlFor="lat">Latitud:</label>
                                <input type="number" step="0.0001" id="lat" name="lat" required />
                            </div>
                            <div>
                                <label htmlFor="lng">Longitud:</label>
                                <input type="number" step="0.0001" id="lng" name="lng" required />
                            </div>
                            <div>
                                <label htmlFor="weight">Intensidad:</label>
                                <input type="number" step="0.1" id="weight" name="weight" />
                            </div>
                            <button type="submit">Agregar Ubicaci&oacute;n</button>
                        </form>
                        <button type="button" onClick={cargarDireccionesDX}>Cargar Direcciones</button>
                        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
                            <HeatmapLayer
                                data={[...locations.map((loc) => loc.location)]}
                                options={{ radius: 20 }}
                            />
                        </GoogleMap>
                    </div>
                  </div>
              </div>
            </div>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
          </section>
          
      </div>
    );
};

export default ReporteMapaCalor;